import { headerLinks } from "./headerLinks";
interface MobileMenuProps {
    onClose: () => void;
}

export const MobileMenu = (props: MobileMenuProps) => {
    return (
        <div className="mobile-only-modal">
            <nav style={{ display: "flex", flexDirection: "column", gap: 20 }}>
                {headerLinks.map((link) => (
                    <a
                        key={link.href}
                        href={link.href}
                        onClick={props.onClose}
                        style={{
                            color: "white",
                            fontSize: "1.5rem",
                            textDecoration: "none",
                        }}
                    >
                        {link.label}
                    </a>
                ))}
            </nav>
            <button
                className="mobile-menu-close-btn"
                onClick={props.onClose}
            >
                X
            </button>
        </div>
    );
};
